module.exports = ".content {\n  width: 90%;\n  margin-left: 5%;\n  margin-right: 5%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/contracts/admin-contracts.component.scss
// module id = ./src/app/admin/contracts/admin-contracts.component.scss
// module chunks = main